import React from "react";
import LegalPage from "../components/LegalPage";
import { BRAND } from "../lib/brand";

export default function Gdpr() {
  return (
    <LegalPage
      eyebrow="Ochrana osobních údajů"
      title="GDPR"
      intro="Zásady zpracování a ochrany osobních údajů dle nařízení (EU) 2016/679 (GDPR)."
      sections={[
        { h: "Správce údajů", p: `Správcem osobních údajů je KAME Autopůjčovna, se sídlem ${BRAND.address.full}, e-mail ${BRAND.email}.` },
        { h: "Jaké údaje zpracováváme", list: [
          "Identifikační a kontaktní údaje (jméno, telefon, e-mail, adresa).",
          "Údaje nezbytné k uzavření a plnění smlouvy o pronájmu vozidla.",
          "Údaje o rezervacích a komunikaci s vámi.",
        ]},
        { h: "Účel a právní základ", p: "Vaše údaje zpracováváme za účelem vyřízení rezervace, uzavření smlouvy o pronájmu a plnění zákonných povinností. Právním základem je plnění smlouvy a náš oprávněný zájem." },
        { h: "Doba uchování", p: "Osobní údaje uchováváme pouze po dobu nezbytně nutnou k naplnění uvedených účelů a po dobu stanovenou právními předpisy." },
        { h: "Vaše práva", list: [
          "Právo na přístup ke svým osobním údajům.",
          "Právo na opravu nebo výmaz údajů.",
          "Právo na omezení zpracování a vznesení námitky.",
          "Právo podat stížnost u Úřadu pro ochranu osobních údajů.",
        ]},
        { h: "Předávání údajů", p: "Vaše osobní údaje nepředáváme třetím stranám bez vašeho souhlasu, s výjimkou případů vyžadovaných zákonem." },
        { h: "Kontakt", p: `Pro uplatnění svých práv nebo v případě dotazů nás kontaktujte na ${BRAND.email}.` },
      ]}
    />
  );
}
